module.exports = {"TXTINS_Next":{"id":"TXTINS_Next","defaultMessage":"Suivant","track":"Next"}}